import {useState, useEffect, useCallback} from 'react';

const STORAGE_KEY = 'forecast_agent_drawer_open';

type UseAgentDrawerReturn = {
	isOpen: boolean;
	openDrawer: () => void;
	closeDrawer: () => void;
};

export function useAgentDrawer(): UseAgentDrawerReturn {
	const [isOpen, setIsOpen] = useState(() => {
		try {
			return sessionStorage.getItem(STORAGE_KEY) === 'true';
		} catch {
			return false;
		}
	});

	useEffect(() => {
		try {
			sessionStorage.setItem(STORAGE_KEY, isOpen ? 'true' : 'false');
		} catch {
			// sessionStorage unavailable
		}
	}, [isOpen]);

	const openDrawer = useCallback(() => setIsOpen(true), []);
	const closeDrawer = useCallback(() => setIsOpen(false), []);

	return {isOpen, openDrawer, closeDrawer};
}
